<template>
  <v-container :class="{'ma-0 pa-1': $vuetify.breakpoint.xs}">
    <EquipmentMainInfo id="mainInfo" :equipmentData="equipmentData" />

    <!-- <AddWorkRequestForms
      id="addWorkRequest"
      v-if="equipmentData.CanAddWorkRequests"
      :equipmentId="equipmentData.EquipmentId"
      :equipmentResolution="true"
    /> -->
    <!-- помінти на цей -->
    <AddWorkRequestForms
      id="addWorkRequest"
      :equipmentId="equipmentData.EquipmentId"
      :equipmentResolution="true"
    />
    <EqiupmentWorkRequestsTable
      id="workRequests"
      :equipmentId="equipmentId"
      v-if="workRequests && workRequests.length"
    />
  </v-container>
</template>

<script>
import EquipmentMainInfo from "../components/EquipmentPassport/EquipmentMainInfo";
import EqiupmentWorkRequestsTable from "../components/EquipmentPassport/EqiupmentWorkRequestsTable";
//import AddWorkRequestForm from "../components/simple-forms/AddWorkRequestForm";
import AddWorkRequestForms from "../components/simple-forms/AddWorkRequestForms";
import { mapActions } from "vuex";

export default {
  name: "EquipmentPassportPage",
  components: {
    EquipmentMainInfo,
    EqiupmentWorkRequestsTable,
    //AddWorkRequestForm,
    AddWorkRequestForms
  },
  props: {
    equipmentId: String
  },
  computed: {
    workRequests() {
      return this.$store.state.equipmentData.passportWorkRequests
    },
    equipmentData() {
      return this.$store.getters.equipmentData
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    currentLocale() {
      return this.$store.getters.currentLocale
    }
  },
  watch: {
    isAuthenticated() {
      this.updateEquipmentData({ equipmentCode: this.equipmentId })
    },
    equipmentId() {
      this.updateEquipmentData({ equipmentCode: this.equipmentId })
    },
    currentLocale() {
      this.updateEquipmentData({ equipmentCode: this.equipmentId })
    }
  },
  mounted() {
    this.reloadData()
  },
  methods: {
    ...mapActions(['updateEquipmentData', 'updatePassportWorkRequests']),
    reloadData() {
      this.updateEquipmentData({ equipmentCode: this.equipmentId }).then(() => {
        this.updatePassportWorkRequests({workRequestId: 0, filterMode: 'byEquipment', AdditionalParams: {equipmentCode: this.equipmentId, showArchive: true }})
      })
    }
  }
}
</script>

<style>
</style>
